import Icon from "core/assets/icons";
import AddImageSwiperButton from "./AddImageSwiperButton";
import { useGetImagePicker, useRemoveImage } from "core/hooks/useImagePicker";
import { ISelectedImage } from 'core/store/upload/actions';
import Image from "core/components/Image";

export default function SelectImage() {
  const communityImages = useGetImagePicker(
    'communityImages',
    true
  )

  const removeImage = useRemoveImage();

  return (
    <div className="flex gap-2 flex-wrap">
      {communityImages.map((img: ISelectedImage, index: number) => (
        <div key={index} className="relative w-[50px] h-[50px]">
          {img.src ? (
            <Image
              src={img.url?.thumbnail || img.src}
              alt="Uploaded"
              className="w-full h-full rounded-md object-cover"
            />
          )
          : (
            <div className="animate-pulse flex w-full rounded-md">
              <div className="w-[50px] h-[50px] bg-gray-300 rounded-md">
                <div className="flex justify-center items-center h-full">
                  {typeof img.file === 'string' ? <img
                    src={img.file}
                    alt="Uploaded"
                    className="w-full h-full rounded-md object-cover opacity-30"
                  />: null}
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    <div className="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {img.src ? <button
            className="absolute top-1 right-1 rounded-full w-[13px] h-[14px]"
            onClick={() => removeImage(img.uuid as string)}
            type="button"
          >
            <img src={Icon.CloseRounded} alt="PlusIcon" className="w-[13px] h-[14px]" />
          </button> : null}
        </div>
      ))}
      <AddImageSwiperButton>      
        <label className="w-[50px] h-[50px] flex items-center justify-center border rounded-md cursor-pointer">
          <img src={Icon.RecipePlus} alt="PlusIcon" />
        </label>
      </AddImageSwiperButton>
    </div>
  );
}
